// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"87":"5952ea1f477732e2f924","301":"a4b7b6c97c16832f3588"}[chunkId] + ".js";
};